/**
 * 互动小说后台的 HTTP 出口 —— `api/novel/*` 的每个能力片都从这里取 http，各片不自己建。
 * `basePath` 把 `/api/novel/admin` 收在一处；每次调用必须带 `routeId`。
 */

import { createCallchainHttp } from '../callchain-http.js'

/** @type {ReturnType<typeof createCallchainHttp>|null} */
let http = null

/**
 * 由 `main.js` 在装配期调一次。
 * @param {Omit<Parameters<typeof createCallchainHttp>[0], 'basePath'>} opts
 */
export function configureNovelAdminHttp(opts) {
  http = createCallchainHttp({ ...opts, basePath: '/api/novel/admin' })
}

/** @returns {ReturnType<typeof createCallchainHttp>} */
export function novelAdminHttp() {
  if (!http) throw new Error('configureNovelAdminHttp must be called before novel admin API use')
  return http
}
